import * as tslib_1 from "tslib";
import { BehaviorSubject, Observable, of, zip as observableZip } from 'rxjs';
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, take, withLatestFrom } from 'rxjs/operators';
import * as user from '../../auth/actions/user';
import * as catalog from '../actions/catalog';
import * as facet from '../actions/facet';
import * as pages from '../../base/actions/pages.actions';
import * as status from '../../base/actions/status.actions';
import * as product from '../actions/product';
import * as fromBase from '../../base/reducers';
import { ThemeConfig } from '../../core/helpers/theme-config';
var catalogRoot = ThemeConfig.get('catalog', 'route-name');
var CatalogEffects = /** @class */ (function () {
    function CatalogEffects(actions$, store, router) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.pagesReady = new BehaviorSubject(false);
        this.getOnLangChange$ = this.actions$.ofType(user.SET_LANGUAGE)
            .pipe(switchMap(function () {
            return _this.actions$
                .ofType(user.SET_SUCCESS)
                .pipe(take(1));
        }), withLatestFrom(this.store.pipe(select(fromBase.getCurrentPageType)), function (action, pageType) { return pageType; }), filter(function (pageType) { return pageType && (pageType.toLowerCase() === 'catalog' || pageType.toLowerCase() === 'search'); }), switchMap(function () { return of(new catalog.Init(true), new status.Reapply()); }));
        this.metaInitShouldRun$ = this.actions$.ofType(catalog.INIT)
            .pipe(map(function (action) { return action.forceRefresh; }), switchMap(function (forceRefresh) { return of(new facet.InitGroups(forceRefresh), new facet.InitFacets(forceRefresh), new product.SetProductDefaultSortOrder()); }));
        this.metaInitComplete$ = observableZip(this.actions$.ofType(facet.GET_GROUPS_SUCCES, facet.GET_GROUPS_SKIPPED, facet.GET_GROUPS_FAILED), this.actions$.ofType(facet.GET_FACETS_SUCCESS, facet.GET_FACETS_SKIPPED, facet.GET_FACETS_FAILED))
            .pipe(switchMap(function (actions) {
            if (_this.pagesReady.getValue())
                return of(actions);
            return _this.actions$.ofType(pages.GET_SUCCESS, pages.GET_FAILED)
                .pipe(map(function (action) { return actions.concat([action]); }), take(1));
        }), map(function (actions) {
            var failed = actions.some(function (action) { return action.type === pages.GET_FAILED
                || action.type === facet.GET_GROUPS_FAILED
                || action.type === facet.GET_FACETS_FAILED; });
            if (failed)
                return new catalog.InitFailed();
            return new catalog.InitSuccess();
        }), catchError(function () { return of(new catalog.InitFailed()); }));
        store.pipe(select(fromBase.isPagesReady))
            .subscribe(this.pagesReady);
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CatalogEffects.prototype, "getOnLangChange$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CatalogEffects.prototype, "metaInitShouldRun$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CatalogEffects.prototype, "metaInitComplete$", void 0);
    return CatalogEffects;
}());
export { CatalogEffects };
